/**
 * Switch Component - Template
 * ===========================
 */

import { BASE_CLASSES } from './constants';

export const SWITCH_TEMPLATE: string = `
<label class="ec-switch" ng-class="$ctrl.getWrapperClasses()">
  <input
    ng-attr-id="{{ $ctrl.resolvedId }}"
    type="checkbox"
    role="switch"
    class="${BASE_CLASSES.input}"
    ng-model="$ctrl.checked"
    ng-change="$ctrl.handleChange()"
    ng-disabled="$ctrl.disabled"
    ng-focus="$ctrl.focused = true"
    ng-blur="$ctrl.focused = false"
    ng-attr-aria-label="{{ (!$ctrl.label && !$ctrl.hasLabelSlot) ? $ctrl.ariaLabel : undefined }}"
  />
  <span ng-if="$ctrl.label || $ctrl.hasLabelSlot" ng-class="$ctrl.getLabelClasses()"><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></span>
  <span ng-class="$ctrl.getTrackClasses()">
    <span ng-class="$ctrl.getKnobClasses()"></span>
  </span>
</label>
`;

export default SWITCH_TEMPLATE;
